export default {
  "content": "<path d=\"M23.707 16.793a1 1 0 01.066 1.34l-.066.074-4.5 4.5-1.414-1.414 2.793-2.793H13v-2h7.586l-2.793-2.793 1.414-1.414 4.5 4.5z\" fill=\"#7B61FF\"/><path d=\"M12 12c1.346 0 2.634.211 3.813.599l-.626 1.9C14.214 14.179 13.137 14 12 14c-4.159 0-7.256 2.308-7.882 5H11v2H3a1 1 0 01-1-1c0-4.638 4.726-8 10-8z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2.5a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};